import {
  usePvReportData,
  useSite,
} from "@inrange/building-manager-api-client";
import { Loading } from "@inrange/theme-components";
import { SitePvReport } from "@inrange/theme-components/site";
import { useParams } from "react-router-dom";

const SitePvReportPage = () => {
  const { orgId, siteId } = useParams<{ orgId: string; siteId: string }>();
  const { fetchSite } = useSite({
    siteId,
    userOrgId: orgId,
    app: "customer",
  });
  const { fetchPvReportData } = usePvReportData(siteId, orgId);

  if (fetchSite.isError) {
    return <div>Error loading the site.</div>;
  }

  if (fetchPvReportData.isError) {
    return <div>Error loading PV report data.</div>;
  }

  if (
    fetchSite.isLoading ||
    !fetchSite.data?.site ||
    fetchPvReportData.isLoading ||
    !fetchPvReportData.data
  ) {
    return <Loading label="Loading report data..." />;
  }

  const site = fetchSite.data.site;
  const { pvPanel, pvInverters, inverterTotalPowerKwAc, lossFactorLabels } =
    fetchPvReportData.data;

  return (
    <SitePvReport
      site={site}
      pvPanel={pvPanel}
      pvInverters={pvInverters}
      inverterTotalPowerKwAc={inverterTotalPowerKwAc}
      lossFactorLabels={lossFactorLabels}
    />
  );
};

export default SitePvReportPage;
